/**
 * @desc 神策
 * @time 2023-08-24 15:23:21
 * @user simxin
 */

// import sensors from 'sa-sdk-javascript';
import { loadScript } from '@src/utils/sandbox/helper';
import { proxy } from '@src/utils/patch/proxy';

export const mountSensor = () => {
  if (process.env.VITE_ENV_NODE_ENV === 'production') {
    loadScript('sensor', 'https://trtc.io/js/shence814.min.js')
      .then(() => {
        window.sensors = (window as any).sensorsDataAnalytic201505;
        window.sensors.init({
          server_url: process.env.VITE_ENV_SENSOR_SERVER,
          is_track_single_page: true,
          use_client_time: true,
          send_type: 'beacon',
          heatmap: {
            clickmap: 'default',
            scroll_notice_map: 'default',
          },
        });
      })
      .catch(() => {});
  } else {
    window.sensors = proxy();
    (window as any).sensorsDataAnalytic201505 = proxy();
  }
};
